/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Direita-à-esquerda",
		"timeZoneID": "Fuso horário",
		"skin": "Estilo",
		"metricsFileImportTask": "Nova Importação a partir de Arquivos",
		"displayMode": "Visualização padrão",
		"credentialRenewed": "Suas credenciais foram renovadas\ncom o ID do usuário e a senha atuais.",
		"productLocale": "Idioma do produto",
		"toggleDisabled": "desligado",
		"credentialChange": "Renovar",
		"log_level_Debug": "Depuração",
		"confirmNewPassword": "Confirmar Nova Senha",
		"unsavedViewMsg2": "Suas mudanças serão perdidas se você não salvá-las primeiro.",
		"supportPortalErrorMessage": "Tente novamente.  Se o problema persistir, entre em contato com o administrador.",
		"legalText": "Materiais licenciados - Propriedade da IBM Corp. © Copyright IBM Corporation e outras 2005, %{year}. IBM, o logotipo IBM, ibm.com e Cognos são marcas ou marcas registradas da International Business Machines Corp., registradas em vários países no mundo todo. Uma lista atual de marcas registradas da IBM está disponível na web em www.ibm.com/legal/copytrade.shtml. Este Programa é licenciado sob os termos do contrato de licença que o acompanha. Esse contrato de licença pode ser localizado em uma pasta de diretório ou biblioteca do Programa identificado como \"License\" ou \"Non_IBM_License\", se aplicável, ou fornecido como um contrato de licença impresso. Leia atentamente o contrato antes de utilizar o Programa. Ao utilizar o Programa, o Cliente concorda com esses termos.",
		"groupsAndRoles": "Grupos e roles",
		"metricsMaintenanceTask": "Nova Manutenção",
		"email": "E-mail",
		"contextual": "Contextual",
		"resetHome": "Redefinir para o padrão",
		"ltr": "Esquerda-à-direita",
		"credentials": "Credencials",
		"logging_congfig_title": "Criação de log",
		"changePasswordTitle": "Alterar minha senha",
		"format": "Formato do relatório",
		"showUnread": "Mostrar não-lidas",
		"AILearning_active": "O AI Learning está em:",
		"docsErrorMessage": "Tente novamente.  Se o problema persistir, entre em contato com o administrador.",
		"toggleEnabled": "sobre",
		"homeSetError": "Ocorreu um erro ao configurar a página inicial padrão, tente fechar e reabrir esta visualização.",
		"passwordChange": "Alterar senha",
		"profile": "Perfil",
		"pdfRestricted": "PDF (Restrito)",
		"drillThrough": "Definições de drill through",
		"homeSet": "Sua página inicial foi configurada com sucesso",
		"regionalOptions": "Opções regionais",
		"myPreferences": "Minhas preferências",
		"defaultHome": "Padrão",
		"version": "Versão",
		"controller": "Controlador",
		"manage": "Gerenciar",
		"biDirectionalFeaturesEnabled": "Suporte a idioma bidirecional",
		"newFeaturesErrorTitle": "O link para Novos recursos não funcionou",
		"passwordMatch": "Senha corresponde",
		"updateProfileAndsettings": "Atualizar perfil e configurações",
		"dashboardConsole": "Espaço de Trabalho",
		"legacyAppsSlideoutLabel": "Aplicativos Anteriores Disponíveis",
		"logging_config_description": "A criação de log é usada para resolução de problemas. Consulte o administrador para\nobter orientação sobre as configurações.",
		"confirmDeletion": "Confirmar Exclusão",
		"signInButtonText": "Login",
		"dataSourceCredentials": "Credenciais do servidor de dados",
		"AILearningConfigurationSlideoutAllyLabel": "Configuração de aprendizagem de IA",
		"loadingSettings": "Carregando configurações",
		"spreadsheetMLRestricted": "Excel (restrito)",
		"manageAILearning": "Aprendizagem de IA",
		"xlsxDataRestricted": "Dados do Excel (restrito)",
		"advanced": "Opções Avançadas",
		"ok": "OK",
		"changeEmail": "Alterar",
		"showHints": "Mostrar sugestões",
		"general": "Geral",
		"xlsxData": "Dados do Excel",
		"newPassword": "Nova senha",
		"hideAll": "Ocultar todos",
		"confirmPassword": "Senha de Confirmação",
		"AILearning_config_description": "Melhore as recomendações do produto, permitindo que o Cognos Analytics aprenda sobre seu uso.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "O link para o Portal de Suporte não funcionou",
		"log_level_Warn": "Aviso",
		"contentSettings": "Configurações de Conteúdo",
		"setHomeButton": "Conjunto",
		"myCapabilities": "Meus recursos",
		"homePage": "Página inicial",
		"helpErrorMessage": "Tente novamente.  Se o problema persistir, entre em contato com o administrador.",
		"loadingProfile": "Carregando perfil",
		"portal": "Portal",
		"metricsPackage": "Novo pacote",
		"myCredentials": "Minhas credenciais",
		"myApiKeys": "Minhas chaves de API",
		"credentialCreate": "Criar",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Impossível atualizar senha",
		"showHiddenObjects": "Mostrar entradas ocultas",
		"csv": "CSV",
		"docsErrorTitle": "O link para Documentação não funcionou",
		"log_level_Error": "Erro",
		"wrongPassword": "Não é possível autenticar",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "Informações",
		"welcomeBanner": "banner Bem-Vindo",
		"helpErrorTitle": "O link para Ajuda não funcionou",
		"contentLocale": "Idioma do conteúdo",
		"pdf": "PDF",
		"oldPassword": "Senha antiga",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Recursos de acessibilidade",
		"manageLogging": "Criação de log",
		"loggingConfigurationSlideoutA11yLabel": "Configuração de Registro",
		"communityErrorTitle": "O link para Comunidade não funcionou",
		"companionApps": "Aplicativos associados",
		"setHomeLabel": "Configurar início como (visualização atual)",
		"metricsExportTask": "Nova Exportação",
		"csvRestricted": "CSV (restrito)",
		"newFeaturesErrorMessage": "Tente novamente.  Se o problema persistir, entre em contato com o administrador.",
		"contributor": "Contribuidor",
		"showAll": "Exibir todos",
		"logging_active": "A criação de log está em:",
		"html": "HTML",
		"profileAndSettings": "Perfil e configurações",
		"baseTextDirection": "Direção de base para o texto",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Senha",
		"invalidEmail": "Inserir um endereço de email válido",
		"credentialCreateSuccess": "Credenciais criadas com sucesso",
		"settings": "Configurações",
		"restrictedFormatSelected": "Você não possui a capacidade para executar relatórios nesse formato, mas é possível acessar relatórios salvos nesse formato.",
		"usageDataDeletionConfirmation": "A exclusão de dados de uso reconfigura qualquer aprendizado de IA.  Tem certeza de que deseja excluir os dados de uso?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Visualizar detalhes",
		"deleteUsageData": "Excluir dados de uso:",
		"showPassword": "Exiba a senha",
		"AILearning_config_title": "Aprendizagem de IA",
		"myPreferencesSlideoutLabel": "Perfil e configurações",
		"passWordChangeSuccess": "Senha mudada com sucesso",
		"logging_level": "Nível de criação de log:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Tente novamente.  Se o problema persistir, entre em contato com o administrador.",
		"cancel": "Cancelar",
		"shareSetError": "Esta ação não pode ser executada antes do fechamento e reabertura da visualização.",
		"passwordNotMatch": "Oops, senha não corresponde",
		"xml": "XML",
		"xmlRestricted": "XML (Restrito)",
		"openMenu": "Abrir menu",
		"closeMenu": 'Fechar o menu'
});